import { trackingClient } from './client';
import { buildPathTo } from '../../navigation/path-builder';

/**
 * Returns a tracking category if the path matches the current location.
 * @param expectedPath Path to match on
 * @param result The expected tracking category on that path
 */
const categoryIfPathMatches = <T>(
  expectedPath: string,
  result: T
): T | null => {
  const { pathname } = window.location ?? {};
  if (expectedPath === pathname) {
    return result;
  }
  return null;
};

/**
 * Either this returns the discover tracking category or null. It should
 * be used with null-safe accessors to call methods.
 */
export const maybeDiscover = () => {
  return categoryIfPathMatches(
    buildPathTo.onlyPath.register.discover({}),
    trackingClient.event.discovery
  );
};

/**
 * Either this returns the email sent tracking category or null. It should
 * be used with null-safe accessors to call methods.
 */
export const maybeActivationEmail = () => {
  // This is ugly, but will have to do for now. Once we can just get the pathname
  // without options (dunno if we want that yet), then this can be updated.
  // This still provides us path safety
  const path = buildPathTo.onlyPath.register.emailSent({ username: 'ignored' });
  return categoryIfPathMatches(
    path,
    trackingClient.event.registrationActivationSent
  );
};
